import { cn } from '@org/ui';

type DeltaTextProps = {
  value: number | null | undefined;
  /** 'points' renders "+8.8", 'percent' renders "+12%". */
  format?: 'points' | 'percent';
  upIsGood?: boolean;
  className?: string;
};

/** A small signed delta next to a table value; grey when zero or unknown. */
export function DeltaText({ value, format = 'points', upIsGood = true, className }: DeltaTextProps) {
  if (value === null || value === undefined || !Number.isFinite(value)) return null;
  const rounded = format === 'percent' ? Math.round(value) : Math.round(value * 10) / 10;
  const sign = rounded > 0 ? '+' : rounded < 0 ? '−' : '';
  const good = rounded === 0 ? null : rounded > 0 === upIsGood;
  return (
    <span
      className={cn(
        'ml-1 text-[11px] tabular-nums',
        good === null ? 'text-muted-foreground' : good ? 'text-emerald-700' : 'text-red-700',
        className,
      )}
    >
      {sign}
      {Math.abs(rounded)}
      {format === 'percent' ? '%' : ''}
    </span>
  );
}
